module.exports = __webpack_public_path__ + "img/open-event-banner.808ef567.png";